import React, { forwardRef } from 'react';

import LoaderIcon from 'component/icon/loader';
import { useClassnames } from 'hook/use-classnames';

import { IProps } from './types';
import style from './style.pcss';

// tslint:disable-next-line:no-any
const Loader = forwardRef<any, IProps>(({theme = 'gray', ...props}, ref) => {
    const cn = useClassnames(style, props.className, true);

    const elTitle = () => {
        if (props.text) {
            return (
                <span className={cn(`loader__text-${theme}`)}>
                    {props.text || 'Загрузка'}
                </span>
            );
        }
    };

    return (
        <div
            className={cn('loader', props.className)}
            ref={ref}
        >
            <LoaderIcon theme={theme} />
            {elTitle()}
        </div>
    );
});

export default Loader;
